import React from 'react';
import styled from 'styled-components';
import { translate } from '../../../common/translation/translate';
import { ErrorBoundaryIcon } from '../../common/errorBoundary/errorBoundaryIcon';
import { mediumMediaQuery } from '../../../common/utilities/sizeHelpers';

interface HurricaneErrorUIProps {
    isMap?: boolean;
    isStories?: boolean;
}

export const HurricaneErrorUI = ({ isMap, isStories }:HurricaneErrorUIProps) : JSX.Element => {
    return (
        <Container isMap={isMap} isStories={isStories}>
            <IconWrapper>
                <ErrorBoundaryIcon fillColor='#8E8E93'/>
            </IconWrapper>
            <NoDataText isTitle={true}>{translate('failedToLoad')}</NoDataText>
            <NoDataDescriptionWrapper>
                <NoDataText>{translate('dataLoadFirstErrorMessage')}</NoDataText>
                <NoDataText>{translate('dataLoadSecondErrorMessage')}</NoDataText>
            </NoDataDescriptionWrapper>
        </Container>
    );
};

interface HurricaneInfoErrorUIProps {
    isHurricanePanel?: boolean;
}

export const HurricaneInfoErrorUI = ({ isHurricanePanel }:HurricaneInfoErrorUIProps): JSX.Element => { 
    return (
        <InfoContainer isHurricanePanel={isHurricanePanel}>
            <IconWrapper hideBorder={true}>
                <ErrorBoundaryIcon fillColor='#8E8E93'/>
            </IconWrapper>
            <NoInfoDataDescriptionWrapper>
                <NoDataText isTitle={true}>{translate('failedToLoad')}</NoDataText>
                <NoDataText> { translate('dataLoadErrorMessage') }.</NoDataText>
            </NoInfoDataDescriptionWrapper>
        </InfoContainer>
    );
};

interface ContainerProps {
    isMap?: boolean;
    isStories?: boolean;
}

const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: column;
    padding: 10px 8px;
    background: #f9f9f9;
    justify-content: center;
    align-items:center;
    width: 100%;
    gap: 12px;
    height: 100%;
    ${({ isMap }) => isMap && 'max-height: 600px;min-height: 320px;'}
    ${({ isStories }) => isStories && `
        min-height: 380px;
        @media (${mediumMediaQuery}) {
            height: 760px;
        }
    `}
`;

interface InfoContainerProps {
    isHurricanePanel?: boolean;
}

const InfoContainer = styled.div<InfoContainerProps>`
    display: flex;
    flex-direction: row;
    padding: ${({ isHurricanePanel }) => isHurricanePanel ? '10px 12px' : '10px 0px'};
    gap: 10px;
    margin-bottom: ${({ isHurricanePanel })=> isHurricanePanel ? '190px' : '20px'}
`;

interface IconWrapperProps {
    hideBorder?: boolean;
}

const IconWrapper = styled.span<IconWrapperProps>`
    display: flex;
    flex-direction: column;
    ${({ hideBorder })=> !hideBorder && 'background: rgba(142, 142, 147, 0.1);'}
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    width: 48px;
    height: 48px;
`;

interface NoDataTextProps {
    isTitle?: boolean;
    isSlimTitle?: boolean;
}

const NoDataText = styled.div<NoDataTextProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    ${({ isSlimTitle })=> !isSlimTitle && `
        justify-content: center;
    `}
    font-family: Source Sans Pro;
    font-style: normal;
    font-size: 16px;
    line-height: 20px;
    color: #333333;
    font-weight: ${({ isTitle }) => isTitle ? '600' : 'normal' };
`;

const NoDataDescriptionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
`;

const NoInfoDataDescriptionWrapper = styled(NoDataDescriptionWrapper)`
    align-items: start;
    gap: 14px;
`;